import { Temporal } from '@js-temporal/polyfill';
export const parseZonedTimeLike = (input) => {
    if (typeof input === 'string') {
        return parseZonedTimeString(input.trim());
    }
    return input;
};
const parseZonedTimeString = (input) => {
    if (input === '') {
        throw new UnparsableZonedTimeStringError(input, 'empty string');
    }
    try {
        const [time, rest] = input.split('[');
        if (time == null) {
            throw new UnparsableZonedTimeStringError(input, 'cannot parse date');
        }
        if (rest == null || rest?.length < 2 || !rest?.endsWith(']')) {
            throw new UnparsableZonedTimeStringError(input, 'cannot parse time zone');
        }
        const plainTime = Temporal.PlainTime.from(time);
        return {
            ...plainTimeToPlainObject(plainTime),
            timeZone: rest.slice(0, -1),
        };
    }
    catch (err) {
        if (err instanceof Error) {
            throw new UnparsableZonedTimeStringError(input, err.message);
        }
        throw new UnparsableZonedTimeStringError(input, 'unknown error');
    }
};
const plainTimeToPlainObject = (plainTime) => ({
    hour: plainTime.hour,
    minute: plainTime.minute,
    second: plainTime.second,
    millisecond: plainTime.millisecond,
    microsecond: plainTime.microsecond,
    nanosecond: plainTime.nanosecond,
});
export class UnparsableZonedTimeStringError extends Error {
    constructor(input, message) {
        super(`Cannot parse ${input} as ZonedTime: ${message}`);
        this.name = this.constructor.name;
    }
}
//# sourceMappingURL=parse-zoned-time-string.js.map